import InputCtrlDirective from './InputCtrlDirective';

export default function () {
    var inputCtrlDirective = new InputCtrlDirective();
    var origLink = inputCtrlDirective.link;
    inputCtrlDirective.link = function (scope) {
        origLink.apply(this, arguments);
        scope.inline = true;
    };

    return inputCtrlDirective;
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/basicinputs/InlineInputCtrlDirective.js
// module id = 1944
// module chunks = 0